<template>
  <div
    id="FAQ"
    class="mx-auto max-w-3xl px-8 py-10 md:py-10 lg:max-w-6xl lg:py-12"
  >
    <h3 class="mx-auto mb-8 px-0 font-sans text-2xl font-semibold text-[#20484F] antialiased lg:mb-0 lg:text-3xl">
      Frequently Asked Questions
    </h3>
    <div>
      <div
        :class="{ flex: variant === 'vertical' }"
        class="relative flex-wrap items-end"
      >
        <ul
          class="relative w-full border-l border-r border-t border-l-gray-100 border-r-gray-100 border-t-gray-100 bg-white lg:absolute lg:left-0 lg:top-16 lg:z-10 lg:w-1/2"
          :class="{ flex: variant === 'horizontal' }"
        >
          <li
            v-for="(tab, index) in tabList"
            :key="index"
            class="border-b border-b-slate-100 px-5 py-5 cursor-pointer"
            :class="{
              'duration-400 translate-x-0 bg-gray-100/70 text-gray-900 transition ease-in-out':
                index + 1 === activeTab,
            }"
            @click="setActiveTab(index + 1)"
          >
            <div class="flex items-center space-x-4">
              <div>
                <div
                  class="h-4 w-4 rounded-full bg-green-500/50"
                  :class="{ '!bg-green-600': index + 1 === activeTab }"
                />
              </div>
              <div class="font-sans text-sm text-gray-800 antialiased">
                {{ tab.title }}
              </div>
            </div>
          </li>
        </ul>
        <template v-for="(tab, index) in tabList">
          <div
            v-if="index + 1 === activeTab"
            :key="index"
            class="h-full w-full rounded-none border border-gray-200 bg-gray-100 px-10 py-8 pl-8 lg:ml-auto lg:h-100 lg:w-3/5 lg:rounded-md lg:px-16 lg:py-16 lg:pl-36"
          >
            <span class="mb-8 block text-lg font-medium">{{ tab.title }}</span>
            <div class="text-sm leading-relaxed text-gray-900 antialiased">
              {{ tab.description }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQSection',
  props: {
    variant: {
      type: String,
      required: false,
      default: () => 'vertical',
      validator: value => ['horizontal', 'vertical'].includes(value),
    },
  },
  data() {
    return {
      activeTab: 1,
      uid: null,
      tabList: [
        {
          title: 'Why is activity data so important in Veridis?',
          description: 'Using activity data instead of financial accounting data allows you to calculate your carbon footprint with more accuracy and granularity. Using activity data also allows for better insights and AI assisted reduction recommendations, e.g. optimizing boiler operations to maintain throughput with lower emissions.',
        },
        {
          title: 'What standards or formats for reporting does Veridis support?',
          description: 'Veridis supports most standard frameworks and guidelines including GRI, CDP, TCFD, SASB and more.',
        },
        {
          title: 'What happens if reporting guidelines change? Do I have to redo all my reports',
          description: 'When there are changes to reporting guidelines, (e.g. IPCC, GRI, etc.) the reports generated by Veridis will be updated so that there will be no need to redo reports from the user end.',
        },
        {
          title: 'Can I use Veridis on my tablet or phone?',
          description: 'Veridis natively supports all major browsers as well as tablets and smart phones.',
        },
      ],
    }
  },

  mounted() {
    this.uid = this.$.uid
  },

  methods: {
    setActiveTab(tabIndex) {
      this.activeTab = tabIndex
    },
  },
}
</script>
